/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WhichPageEnum } from './WhichPageEnum';
import { WhichPageEnumFromJSON, WhichPageEnumFromJSONTyped, WhichPageEnumToJSON } from './WhichPageEnum';

/**
 *
 * @export
 * @interface Comment
 */
export interface Comment {
  /**
   *
   * @type {number}
   * @memberof Comment
   */
  readonly id: number;
  /**
   *
   * @type {number}
   * @memberof Comment
   */
  useCase: number;
  /**
   *
   * @type {string}
   * @memberof Comment
   */
  content: string;
  /**
   *
   * @type {string}
   * @memberof Comment
   */
  readonly user: string;
  /**
   *
   * @type {WhichPageEnum}
   * @memberof Comment
   */
  whichPage?: WhichPageEnum;
  /**
   *
   * @type {Date}
   * @memberof Comment
   */
  readonly timestamp: Date;
  /**
   *
   * @type {Date}
   * @memberof Comment
   */
  readonly lastModified: Date;
}

/**
 * Check if a given object implements the Comment interface.
 */
export function instanceOfComment(value: object): value is Comment {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('useCase' in value) || value['useCase'] === undefined) return false;
  if (!('content' in value) || value['content'] === undefined) return false;
  if (!('user' in value) || value['user'] === undefined) return false;
  if (!('timestamp' in value) || value['timestamp'] === undefined) return false;
  if (!('lastModified' in value) || value['lastModified'] === undefined) return false;
  return true;
}

export function CommentFromJSON(json: any): Comment {
  return CommentFromJSONTyped(json, false);
}

export function CommentFromJSONTyped(json: any, ignoreDiscriminator: boolean): Comment {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    useCase: json['use_case'],
    content: json['content'],
    user: json['user'],
    whichPage: json['which_page'] == null ? undefined : WhichPageEnumFromJSON(json['which_page']),
    timestamp: new Date(json['timestamp']),
    lastModified: new Date(json['last_modified']),
  };
}

export function CommentToJSON(value?: Omit<Comment, 'id' | 'user' | 'timestamp' | 'lastModified'> | null): any {
  if (value == null) {
    return value;
  }
  return {
    use_case: value['useCase'],
    content: value['content'],
    which_page: WhichPageEnumToJSON(value['whichPage']),
  };
}
